import React from "react";
import DataDevis from "../dataDevis";
import './sinistres.css'

export default class Sinistres extends React.Component {
    
    constructor(props) {
        super(props);
    }
   
    render() {
        
        const me = this
        const {devis,changeParams,showValidate,focusError} = this.props.container

        let counter = 1
        const sinistres = devis.getSinistres()
        return ( !sinistres.length )?<h3>Vous n'avez déclaré aucun sinistre</h3>
            : <>{devis.getSinistres().map(
            sinistre => {
                const {type,date} = sinistre
                return <div key={counter} className="sinistre"><h2>Sinistre n°{counter++} 
                <span title="Supprimer" className="delete_button" onClick={devis.removeSinistre.bind(devis,type,date,changeParams)}>x</span></h2>
                <label>{DataDevis.sinistreTypeToDisplay[type]}, le {date}</label></div>
            }
        )}</>

    }
}